import ToastError from "../components/molecules/ToastError"
import { loc } from "../core/utils"
import { TunnelDataContext } from "../digital-journey/context/TunnelDataContext"
import { postUploadDocument } from "../service/postUploadDocument"
import React from "react"
import { useContext } from "react"
import toast from "react-hot-toast"
import { useMutation } from "react-query"

export default function useUploadDocuments(setShowUploadDoc, documentTypesOptions) {
  const { tunnelData } = useContext(TunnelDataContext)
  const transactionId = tunnelData?.data?.order?.id

  const { mutate, isLoading: isLoadingUpload } = useMutation(
    (datas) => postUploadDocument({ ...datas, tunnelData, transactionId, documentTypesOptions }),
    {
      mutationKey: "upload-documents",
      onSuccess: () => {
        toast.success(loc("upload_toast_success"))
        setShowUploadDoc(false)
      },
      onError: (err) => {
        toast.error(
          (t) => (
            <ToastError message={`${loc("upload_toast_fail")}${err}`} handlePictoClick={() => toast.dismiss(t.id)} />
          ),
          {
            id: err,
            duration: Infinity
          }
        )
        return err
      }
    }
  )

  return { mutate, isLoadingUpload }
}
